import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { AppSecurityService } from "../services";

export const LeadsGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    const router: Router = inject(Router);
    const appSecuritySevice: AppSecurityService = inject(AppSecurityService);

    return appSecuritySevice.ensureFeaturesLoaded().pipe(
        map(() => appSecuritySevice.hasAccessToLeadsArea()
            ? true
            : router.createUrlTree(['/access-denied'], { queryParams: { returnUrl: state.url } }))
    );
}